import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { CompetitionsTable } from "features/competition/CompetitionsTable";
import { useEffect } from "react";
import "style/discoverPage.css";

export function CompetitionListPage() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	return (
		<div className="discover-container discover-container--wide">
			<CompetitionsTable />
		</div>
	);
}

export default CompetitionListPage;
